<template>
  <div class="content-box">
    <Banner />
    <!-- <section class="nav-link-box">
      <Link v-for="(item, index) in linkNav" :nav="item" :key="index" />
    </section>
    <section>
      <Title :title="'最新专辑'">
        <span id="change-group" @click="changeClick">{{ home.newAlumList.length ? '换一批' : '返回' }}</span>
      </Title>
      <article class="list-box" v-if="home.newAlumList.length">
        <Gallery v-for="item in home.newAlumList" :source="'newAlbum'" :gallery="item.album" :key="item.id" />
      </article>
      <p v-else>已经到底啦～</p>
    </section>
    <section>
      <Title :title="'图片标签'" />
      <article class="tag-list">
        <Tag v-for="(item, index) in home.labels" :origin="'meinvtupian'" :label="item" :key="index"/>
      </article>
    </section> -->
  </div>
</template>

<script>
  import gql from '@/graphql/graphql'
  import Banner from '@/components/Banner'
  import Link from '@/components/Link'
  import Gallery from '@/components/GalleryM'
  import Title from '@/components/TitleM'
  import Tag from '@/components/Tag'
  import { mapGetters } from 'vuex'

  export default {
    // asyncData ({ store }) {
    //   const param = { ...store.state.params };
    //   param.query = gql.GET_HOME_DATA;
    //   param.variables.bannerLocationKey = 'wapHomePageWebBannerConfig';
    //   param.variables.labelLocationKey = 'wepHomepageHotWebLabelsConfig';
    //   param.variables.pageSize = 4;

    //   return store.dispatch('getHomeData', param)
    // },
    components: { Banner, Link, Gallery, Title, Tag },
    computed: {
      ...mapGetters({
        home: 'homeData',
        linkNav: 'linkNav'
      }),
    },
    methods: {
      changeClick () {
        const param = { ...this.$store.state.params };
        param.query = gql.GET_LAST_ALBUM_LIST;
        param.variables.pageSize = 4;
        if (this.home.newAlumList.length) {
          param.variables.page += 1;
        } else {
          param.variables.page = 1;
        }

        return this.$store.dispatch('changeLastAlbum', param)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .content-box {
    overflow-x: hidden;
  }
  .nav-link-box {
    text-align: center;
  }
  #change-group {
    color: #F43F43;
  }
</style>



// WEBPACK FOOTER //
// src/views/Home.vue